import { render, staticRenderFns } from "./CtaSponsors.vue?vue&type=template&id=68d262e7&"
import script from "./CtaSponsors.vue?vue&type=script&lang=js&"
export * from "./CtaSponsors.vue?vue&type=script&lang=js&"
import style0 from "./CtaSponsors.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports